import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroPricing'
import QuadColumn from '../components/quadColumn__benefits'
import TriColumn__testimonials from '../components/triColumn__testimonials'
import TriColumn__FAQ from '../components/triColumn__FAQ'
import CTA from '../components/cta'
import Footer from '../components/footer'

export default class extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Head title="Official High School Esports | PlayVS" description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship." keywords="high school esports" />

          <Header />

          <Intro />

          <QuadColumn />

          <TriColumn__testimonials />

          <TriColumn__FAQ />
          
          <CTA />

          <Footer />
          
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/pricing.js